<template>
    <div class="p-12 container">
        <h2>Confirm Domains</h2>

        <ul class="breadcrumb bg-grey-100 rounded p-4 mb-8">
            <li class="breadcrumb-item"><router-link to="/order">Order</router-link></li>
            <li class="breadcrumb-item"><router-link to="/order/domain">Domains</router-link></li>
            <li class="breadcrumb-item active">Confirm Domains</li>
        </ul>

        <div class="flex flex-wrap">
            <div class="w-full pb-8 md:w-2/3 md:pr-4">
                <div
                    :key="index"
                    class="border p-8 mb-8"
                    v-for="(domain, index) in questionableDomains"
                >
                    <h3 class="mb-2 text-2xl text-green">{{ domain.domain }}</h3>
                    <template>
                        <p v-if="domain.domain.toLowerCase().includes('.org.au')" class="mb-6">
                            To register this domain you must be an Australian charity or non-profit organisation.
                        </p>
                        <p v-if="domain.domain.toLowerCase().includes('.asn.au')" class="mb-6">
                            To register this domain you must be an Australian incorporated association, political
                            party, trade union, or a sporting or special interest club.
                        </p>
                        <p v-if="domain.domain.toLowerCase().includes('.com.au') || domain.domain.toLowerCase().includes('.net.au')" class="mb-6">
                            To register this domain you must be an Australian registered company or business.
                        </p>
                        <p v-if="domain.domain.toLowerCase().endsWith('.au')">
                            <span>The Registrant ID you provide must have a likeness to the domain name being registered. For more information please review the </span>
                            <a 
                                href="https://www.auda.org.au/policy/au-domain-administration-rules-licensing#2-4" 
                                title=".au Domain Administration Rules: Licensing"
                                target="_blank">
                                AUDA eligibility policy
                            </a>
                            <span>.</span>
                        </p>
                    </template>
                    <form :ref="domain.slug" @submit.prevent="">
                        <sau-dynamic-input
                            v-for="(input, index) in domain.questions.inputs"
                            :key="index"
                            :input="input"
                            class="form-group"
                            :class="{
                                '.mb-4': domain.questions.inputs.length !== index + 1,
                                '.mb-0': domain.questions.inputs.length === index + 1,
                            }"
                        ></sau-dynamic-input>
                    </form>
                </div>
            </div>

            <div class="w-full md:w-1/3 md:pl-4">
                <div id="order-summary-link" class="goto-link-offet"></div>
                <div class="border md:border-0 md:shadow-sau-lg p-8 bg-white">
                    <order-summary
                        :data="data"
                        :order="order"
                        @domain-errors="errorsForDomain"
                        @clear-domain-errors="clearErrorsForDomain"
                    ></order-summary>
                </div>
                <div class="text-center mt-6">
                    <img src="/img/geotrust.png" class="w-full" style="max-width: 7.5rem !important;">
                    <small class="text-grey text-xs block">
                        Secure payments with GeoTrust 256-bit encryption
                    </small>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import OrderSummary from './Summary';

export default {
    props: {
        data: Object,
        order: Object,
    },

    components: {
        OrderSummary,
    },

    computed: {
        domains() {
            return this.order.items.filter(item => item.type === 'domain');
        },

        questionableDomains() {
            return this.domains.filter(domain => domain.questions);
        },
    },

    methods: {
        domainHasError(domain) {
            return domain.questions.inputs.filter(i => i.errors.length).length > 0;
        },

        clearErrorsForDomain: function (domainSlug) {
            this.order.items = this.order.items.map(item => {
                if (item.type === 'domain' && item.slug === domainSlug && item.questions) {
                    item.questions.inputs = item.questions.inputs.map(input => {
                        input.errors = [];
                        return input;
                    });
                }

                return item;
            });

            // Not reacting.
            this.$children.forEach(e => {
                e.$children.forEach(e => {
                    e.$forceUpdate();
                });
            });
        },

        errorsForDomain: function (domainSlug, errors) {
            this.order.items = this.order.items.map(item => {
                if (item.type === 'domain' && item.slug === domainSlug && item.questions) {
                    item.questions.inputs = item.questions.inputs.map(input => {
                        input.errors = errors[input.name] ? errors[input.name] : [];
                        return input;
                    });
                }

                return item;
            });

            // Not reacting.
            this.$children.forEach(e => {
                e.$children.forEach(e => {
                    e.$forceUpdate();
                });
            });
        },
    },

    watch: {
        questionableDomains(val) {
            if (val.length === 0 && this.$route.path.startsWith('/order/confirm-domains')) {
                this.$router.push('/order/view');
            }
        },
    },
}
</script>
